export function useCurrentUrl(): string {
  return window.location.href;
}
